import LegalDocumentPage from '../components/legal-page/LegalDocumentPage';

export default function PrivacyPage() {
  return <LegalDocumentPage pageKey="privacy" />;
}
